











































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IWallet } from "@/interfaces";
import WalletVoters from "@/components/wallet/Voters.vue";

@Component({
  components: {
    WalletVoters,
  },
})
export default class WalletDelegate extends Vue {
  @Prop({ required: true }) public wallet: IWallet;

  get delegate() {
    return this.$store.getters["delegates/byPublicKey"](this.wallet.publicKey);
  }

  get delegateStatus() {
    const activeThreshold = this.$store.getters["network/activeDelegates"];
    if (this.wallet.isResigned) {
      return { text: this.$t("WALLET.DELEGATE.STATUS.RESIGNED"), class: "text-status-not-forging" };
    }
    if (this.delegate.rank && this.delegate.rank <= activeThreshold) {
      return { text: this.$t("WALLET.DELEGATE.STATUS.ACTIVE"), class: "text-status-forging" };
    }
    return { text: this.$t("WALLET.DELEGATE.STATUS.STANDBY"), class: "text-status-missed-round" };
  }
}
